<template>
  <div class="header-page">
    <div class="head-item">
      <div style="padding: 0px 15px 0px 0px;" @click="toggleClick">
        <svg
          :class="{'is-active': isCollapse}"
          class="hamburger"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64">
          <path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z" />
        </svg>
      </div>
      <!-- <div class="icon"></div> -->
      <div class="title">
        <span v-if="projectName" class="project-name">{{ projectName }}</span>
        <!-- sys-tenant users have no real hospital/department — show a localized
             system-admin label instead of the placeholder org name. -->
        <span v-if="user.tenantCode === 'sys'">{{ t('header.systemAdminConsole') }}</span>
        <template v-else>
          <span v-if="commomStore.hospitalName">
            {{ commomStore.masking ? t('header.maskedHospital') : commomStore.hospitalName }}
          </span>
          <span></span>
          <span v-if="commomStore.departmentName">-{{ commomStore.departmentName }}</span>
        </template>
      </div>
    </div>
    <div class="head-item">
      <!-- Language picker intentionally lives only on the login page and inside
           the Settings dialog (设置, via the avatar menu) — not in the top nav. -->
      <el-dropdown
        class="avatar-dropdown"
        popper-class="avatar-dropdown__popper"
        trigger="hover"
        :show-timeout="80"
        :hide-timeout="260"
        @command="handleCommand"
      >
        <el-avatar shape="square" :size="32" :src="user.avatar" />
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-if="user.tenantCode === 'sys'"
              command="changeTenant"
              style="color: darkred"
            >
              {{ t('header.switchTenant') }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="user.tenantCode === 'sys'"
              command="configForm"
              style="color: dodgerblue"
            >
              {{ t('header.configForm') }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="routePath !== '/person/project'"
              command="project"
            >
              {{ t('header.switchProject') }}
            </el-dropdown-item>
            <el-dropdown-item command="settings">{{ t('header.settings') }}</el-dropdown-item>
            <el-dropdown-item divided command="logout">{{ t('header.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="user-name">{{ user.name }}</div>
    </div>
  </div>

  <!-- Settings + its sibling profile dialogs were extracted out of this file.
       header.vue stays the orchestrator: it owns the visibility flags and
       swaps Settings → Password / Avatar when those rows are clicked. -->
  <SettingsDialog
    v-model:visible="settingsDialogVisible"
    :init-pwd="initPwd"
    @open-password="onOpenPassword"
    @open-avatar="onOpenAvatar"
  />
  <ChangePasswordDialog v-model:visible="dialogVisible" :init-pwd="initPwd" />
  <AvatarDialog v-model:visible="headDialogVisible" />
</template>

<script setup lang="ts">
import { clearToken } from "@/utils/common"
import { useCommonStore, useUserStore } from "@/store/common"
import { ElMessage } from "element-plus"
import { useI18n } from "vue-i18n"
import { changeTenant } from "@/api/login"
import { useProjectInfoStore } from "@/store/project"
import SettingsDialog from "./components/SettingsDialog.vue"
import ChangePasswordDialog from "./components/ChangePasswordDialog.vue"
import AvatarDialog from "./components/AvatarDialog.vue"

const { t } = useI18n();

const projectInfoStore = useProjectInfoStore();
const route = useRoute();

const props = defineProps({
  showProect: {
    type: Boolean,
    default: false
  }
})

const routePath = computed(() => {
  return route.path;
});

const projectName = computed(() => {
  if (props.showProect) {
    return projectInfoStore.projectInfo.projectName;
  } else {
    return "";
  }
});

const commomStore = useCommonStore()
const userStore = useUserStore()
const isCollapse = defineModel();

const router = useRouter();
const initPwd = ref(false);

const user = computed(() => {
  return userStore.userInfo
})

const dialogVisible = ref(false);
const headDialogVisible = ref(false);
const settingsDialogVisible = ref(false);

const toggleClick = () => {
  isCollapse.value = !isCollapse.value;
}

const handleCommand = (name:string) => {
  switch (name) {
    case "logout":
      clearToken();
      router.push({
        path: "/login"
      })
      break;
    case "changeTenant":
      //confirm new tenant code
      const tenantCode =  window.prompt(t('header.tenantCodePrompt'))!.trim()
        if (tenantCode) {
          //change
        changeTenant({
          tenantCode: tenantCode
        }).then((res:any) => {
          ElMessage.success(t('common.opSuccess'))
            //刷新页面
            //location.reload();
        })
        }
      break;
    case "configForm":
      //confirm new tenant code
        if (!projectInfoStore.projectInfo.id) {
          projectInfoStore.fetchProjectInfo();
        }
        window.open('/manage/database?id='+projectInfoStore.projectInfo.id+'&name='+projectInfoStore.projectInfo.projectName)
      break;
    case "project":
        router.push({
          path: '/person/project'
        });
      break;
    case 'settings':
      settingsDialogVisible.value = true;
      break;
    default:
      break;
  }
}

// The Settings dialog closes itself before a follow-up opens so the
// child dialog isn't visually stacked on top of the parent.
const onOpenPassword = () => {
  settingsDialogVisible.value = false;
  dialogVisible.value = true;
}

const onOpenAvatar = () => {
  settingsDialogVisible.value = false;
  headDialogVisible.value = true;
}

onMounted(() => {
  userStore.getInfo((info:any) => {
    initPwd.value = info.initPwd;
  });

  projectInfoStore.fetchProjectInfo();
})
</script>

<style scoped lang="scss">
.header-page {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0px 16px;
  box-sizing: border-box;
  .head-item {
    display: flex;
    align-items: center;
    .icon {
      width: 18px;
      height: 18px;
      background-color: #D9D9D9;
    }
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #303133;
      line-height: 24px;
      margin-left: 8px;
      .project-name {
        padding-right: 26px;
      }
    }
  }
  .user-name {
    font-weight: 400;
    font-size: 14px;
    color: #303133;
    padding-left: 8px;
    padding-right: 20px;
  }
  .hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
  .hamburger.is-active {
    transform: rotate(180deg);
  }
}
.el-avatar {
  --el-avatar-bg-color: transparent;
}
</style>
<style>
.el-dropdown-menu {
  --el-dropdown-menuItem-hover-color: #26C1BD;
}
</style>

<style lang="scss">
/* Avatar dropdown — forgiving hover gestures.
   A single dropdown-menu (no gaps between sub-wrappers) keeps the
   hover region contiguous; extra invisible padding above the popper
   box bridges the small gap between the avatar trigger and the popper
   box so tracking off the trigger doesn't instantly close the menu. */
.avatar-dropdown__popper.el-popper {
  padding: 4px 0;
}
.avatar-dropdown__popper .el-dropdown-menu {
  padding: 4px 0;
  min-width: 140px;
}
.avatar-dropdown__popper .el-dropdown-menu__item {
  padding: 8px 20px;
  line-height: 1.4;
}
.avatar-dropdown__popper .el-dropdown-menu__item--divided {
  margin-top: 4px;
}
.avatar-dropdown__popper .el-dropdown-menu__item--divided::before {
  margin: 0;
}
</style>
